import type { FC } from 'react';
import type { Request } from '@/model/Request.model';
import ApprovalRequestDetails from '@/components/Approvals/ApprovalRequestDetails';
import { ApprovalSection } from '@/components/Studies/Show';
import FormRender from '@/components/UI/FormRender';
import { _notNil } from '@/littledash';
import { FormProvider, useForm } from 'react-hook-form-latest';

interface RequestFormSummaryProps {
  request: Request;
}

const RequestFormSummary: FC<RequestFormSummaryProps> = ({ request }) => {
  const formMethods = useForm({
    defaultValues: request.form_data,
  });

  const { study } = request;

  return (
    <>
      {_notNil(study) && <ApprovalRequestDetails study={study} />}
      <FormProvider {...formMethods}>
        <FormRender
          groups={request.request_template.form.groups}
          groupContainer={ApprovalSection}
          submitted
          hookFormVersion="latest"
        />
      </FormProvider>
    </>
  );
};

export default RequestFormSummary;
